import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34fcef6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "star-content-audio" }
const _hoisted_2 = {
  key: 0,
  class: "media-container"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "controls" }
const _hoisted_5 = {
  key: 1,
  class: "tts-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mediaFile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("audio", {
            ref: "audioRef",
            src: _ctx.mediaFile,
            controls: "",
            controlsList: "nodownload noplaybackrate",
            class: "audio-player"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "ctrl-btn speed",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePlaybackSpeed && _ctx.togglePlaybackSpeed(...args)))
            }, _toDisplayString(_ctx.playbackSpeed) + "x", 1),
            _createElementVNode("button", {
              type: "button",
              class: "ctrl-btn seek",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.seekBackward && _ctx.seekBackward(...args)))
            }, "-15s"),
            _createElementVNode("button", {
              type: "button",
              class: "ctrl-btn seek",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.seekForward && _ctx.seekForward(...args)))
            }, "+15s")
          ])
        ]))
      : (_ctx.plainText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["voice-icon", { playing: !_ctx.isPaused }]),
              "aria-hidden": "true"
            }, null, 2),
            _createElementVNode("button", {
              type: "button",
              class: "tts-btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onToggleTts && _ctx.onToggleTts(...args)))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["tts-btn-icon", _ctx.isPaused ? 'is-play' : 'is-pause'])
              }, null, 2)
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}